import React from "react";
import moment from "moment";

const UnixTimeDisplay = props => {
  const { timestamp, format } = props;

  return <span>{moment.unix(timestamp).format(format)}</span>;
};
export default UnixTimeDisplay;
